module.exports = __webpack_public_path__ + "static/media/banner-background.12b13c81.png";